import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Dialogs, Notifications, Tooltips } from 'excellence-ui';
import { DemoCookieBannerDialog } from './features/demo/dialogs/demo-cookie-banner-dialog/demo-cookie-banner-dialog';
import { IsDemoModeDirective } from './features/demo/directives/is-demo-mode';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Notifications,
    Dialogs,
    Tooltips,
    DemoCookieBannerDialog,
    IsDemoModeDirective,
  ],
  templateUrl: './app.html',
})
export class App {}
